// extracted by mini-css-extract-plugin
export default {"error404Logo":"error404_error404Logo__q7xlM","error404Container":"error404_error404Container__7q3en","error404Emoji":"error404_error404Emoji__lejw5"};